import FieldUser from "../user/user";
import FieldConfig from "../../proto/field-config";
import {PopoverMenuItemType} from "../../../gd-components/popover-menu/popover-menu/const";
import FieldUser_DeletedUsersMenu from "./components/deleted-users-menu/deleted-users-menu";
import FieldUserAndDeleted_PopoverOption from "./components/option/option-user";
import CompanyUser from "../../../model2/company-user-new/company-user";


export default class FieldUserAndDeleted extends FieldUser {

    constructor(config: FieldConfig) {
        super(config);

        this.components.PopoverOption = FieldUserAndDeleted_PopoverOption
    }

    getOptions() {

        let options : Options = super.getOptions()

        options = [...options, ...[
            {
                type: PopoverMenuItemType.SEPARATOR
            },
            {
                icon            : "i5-users",
                label           : "Deleted users",
                type            : PopoverMenuItemType.CUSTOM_POPOVER,
                menuComponent   : FieldUser_DeletedUsersMenu,
            }
        ]]

        return options
    }

    // New
    getDeletedUsersOptions(): Options {

        return _.map(gd.session.deletedCompanyUsers.models, (companyUser: CompanyUser)=> {
            return {
                value: companyUser.userId,
                label: companyUser.name,
            }
        })
    }
}
